export const AG_GENERATE_PRIORITIES = [
    'speed',
    'balanced',
    'quality',
] as const;

export type AgGeneratePriority = (typeof AG_GENERATE_PRIORITIES)[number];
